import { Box } from '@chakra-ui/react';

type Props = {
  width?: number | string | (number | string | null)[];
  height?: number | string | (number | string | null)[];
  grow?: number;
  shrink?: number;
};

const Spacer = ({ grow, height = 1, shrink, width = 1 }: Props) => (
  <Box flexGrow={grow} flexShrink={shrink} height={height} width={width} />
);

export default Spacer;
